import {BaseModel} from "./base-model";
import {Utils} from "../utils";

export class Location extends BaseModel {

  protected static self = Location;

  address: string;
  address2: string;
  city: string;
  zip: string;
  country: string;
  provinceInitials: string;
  latitude: number;
  longitude: number;
  altitude: number;

  public isEmpty() {
    return Utils.isEmpty(this.address) && Utils.isEmpty(this.address2) && Utils.isEmpty(this.city) && Utils.isEmpty(this.zip) && Utils.isEmpty(this.country) && Utils.isEmpty(this.provinceInitials) && this.latitude == null && this.latitude == null;
  }

  public validate(): boolean {
    return !Utils.isEmpty(this.address) && !Utils.isEmpty(this.city) && !Utils.isEmpty(this.zip) && !Utils.isEmpty(this.country) && this.latitude > 0 && this.longitude > 0;
  }
}
